import {
  ExternalGameBannerFromBackend,
  ExternalGameInfoByIdFromBackend,
  ExternalGamesFromBackend,
} from './types';

import { URL } from '../../constants';
import type { ServiceConfig } from '../../utils/create-http-api-service';
import { defaultRequestService } from '../../utils/default-request-service';

// ---

export const getAllExternalGames = (config: ServiceConfig) => {
  type AdapterProps = { response: ExternalGamesFromBackend };
  return defaultRequestService<AdapterProps>(URL.EXTERNAL_GAMES, config.instance.get);
};

// ---

export const getExternalGameById = (
  config: ServiceConfig,
  gameId: string,
) => {
  type AdapterProps = { response: ExternalGameInfoByIdFromBackend };
  const url = `${URL.EXTERNAL_GAMES}/game?id=${gameId}`;

  return defaultRequestService<AdapterProps>(url, config.instance.get);
};

export const getExternalGameBannerById = (
  config: ServiceConfig,
  gameId: string,
) => {
  type AdapterProps = { response: ExternalGameBannerFromBackend };
  const url = `${URL.EXTERNAL_GAMES}/${gameId}`;

  return defaultRequestService<AdapterProps>(url, config.instance.get);
};
